import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/other/tooltip.module.css";

export default {
  "tooltipDefaultContainer": "tooltip-module__tooltipDefaultContainer_GsG6va__100",
  "tooltipDefaultContainerParagraph": "tooltip-module__tooltipDefaultContainerParagraph_GsG6va__100",
  "tooltipDetailsContainer": "tooltip-module__tooltipDetailsContainer_GsG6va__100",
  "tooltipDetailsContainerHidden": "tooltip-module__tooltipDetailsContainerHidden_GsG6va__100"
};
      